import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-date-range',
  templateUrl: './date-range.component.html',
  styleUrls: ['./date-range.component.scss']
})
export class DateRangeComponent implements OnInit, OnChanges {
  hoveredDate: NgbDate | null = null;
  fromNgDate: NgbDate;
  toNgDate: NgbDate | null = null;

  @Input() fromDate: string;
  @Input() toDate: string;

  @Output() select = new EventEmitter();

  constructor(private calendar: NgbCalendar) {
    this.fromNgDate = this.calendar.getToday();
    this.toNgDate = this.calendar.getNext(this.calendar.getToday(), 'd', 10);
    this.fromDate = this.format(this.fromNgDate);
    this.toDate = this.format(this.toNgDate);
  }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.fromNgDate = this.convertDate(this.fromDate);
    this.toNgDate = this.convertDate(this.toDate);
  }

  onDateSelection(date: NgbDate) {
    if (!this.fromNgDate && !this.toNgDate) {
      this.fromNgDate = date;
    } else if (this.fromNgDate && !this.toNgDate && date.after(this.fromNgDate)) {
      this.toNgDate = date;
      this.select.next({
        from: this.format(this.fromNgDate),
        to: this.format(this.toNgDate)
      });
    } else {
      this.toNgDate = null;
      this.fromNgDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return (
      this.fromNgDate && !this.toNgDate && this.hoveredDate && date.after(this.fromNgDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.toNgDate && date.after(this.fromNgDate) && date.before(this.toNgDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.fromNgDate) ||
      (this.toNgDate && date.equals(this.toNgDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }

  private format(date: NgbDate) {
    const m = date.month < 10 ? `0${date.month}` : date.month;
    const d = date.day < 10 ? `0${date.day}` : date.day;
    return `${date.year}-${m}-${d}`;
  }

  private convertDate(date: string) {
    const [y, m, d] = date.split('-').map((p) => parseInt(p, 10))
    return new NgbDate(y, m, d);
  }
}
